<div class="search-container">
  <ng-container *ngIf="!detailMode">
    <ng-container *ngTemplateOutlet="briefContainer"></ng-container>
  </ng-container>

  <ng-container *ngIf="detailMode">
    <ng-container *ngTemplateOutlet="detailedResultSection"></ng-container>
  </ng-container>
</div>

<ng-template #briefContainer>
  <ng-container *ngIf="showDefaultView">
    <div class="default-wrapper">
      <search-suggestion-view></search-suggestion-view>
    </div>
  </ng-container>
  <ng-container *ngIf="!showDefaultView">
    <search-brief-result
      [searchResult]="searchResult"
      [query]="searchedQuery"
    ></search-brief-result>
  </ng-container>
</ng-template>

<ng-template #detailedResultSection>
  <ng-container *ngIf="detailedSearchResult?.length > 0">
    <div class="result-header">
      <shared-button
        color="primary"
        variant="stroke"
        icon="/assets/images/icons/sort-alt.svg"
        mode="dropdown"
        [dropdownOptions]="dropdownOptions"
      >
        <ng-container *ngIf="!selectedSortLabel">Sort By</ng-container>
        <ng-container *ngIf="selectedSortLabel">{{
          selectedSortLabel
        }}</ng-container>
      </shared-button>
      <div class="header-info">
        <p *ngIf="resultCount" class="header-info-text">
          Result Found: <span class="text-bold">{{ resultCount }}</span>
        </p>
      </div>
    </div>
    <div class="result-container">
      <div class="result-card-container">
        <shared-product-card
          *ngFor="let item of detailedSearchResult"
          [product]="item"
          [capturedQuery]="searchedQuery"
        ></shared-product-card>
      </div>
    </div>
  </ng-container>
  <div class="no-result-container" *ngIf="detailedSearchResult?.length === 0">
    <img
      class="no-result-image"
      src="/assets/images/icons/no-result-details.svg"
      alt=""
    />
    <p class="no-result-context">Unfortunately, no results found!</p>
    <a
      class="action-button"
      [routerLink]="['/category/all']"
      mat-button
      color="primary"
      >Go to Categories</a
    >
  </div>
</ng-template>
